// src/seo/ResearchSchema.jsx
import React from 'react'
import resources from '../data/researchResources.json'

const SITE = 'https://www.roman-storyworld.link'

function toAbs(url) {
  return url.startsWith('http') ? url : SITE + url
}
function imgAbs(path) {
  return path?.startsWith('/') ? SITE + path : path
}

export default function ResearchSchema({ pageUrl = SITE + '/research' }) {
  const listItems = resources.map((r, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    url: toAbs(r.url),
    name: r.title,
    image: imgAbs(r.backgroundImage),
  }))

  const data = [
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': pageUrl + '#webpage',
      url: pageUrl,
      name: 'Research Resources — Roman Storyworld',
      description:
        'Curated research sources and interactive tools for Roman Britain: datasets, reports, inscriptions, roads, forts, amphitheatres, mosaics and sacred sites.',
      isPartOf: { '@type': 'WebSite', name: 'Roman Storyworld', url: SITE },
      inLanguage: 'en-GB'
    },
    {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      '@id': pageUrl + '#resources',
      name: 'Research Resources',
      url: pageUrl,
      numberOfItems: listItems.length,
      itemListElement: listItems
    }
  ]

  return (
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />
  )
}
